module.exports = __webpack_public_path__ + "static/oleg-98b57f9513388770baef9fde97264012.png";